import { getSdk, ProfileQuery, Sdk } from "@/__generated__/sdk";
import { Session } from "next-auth";
import { BaseGqlClientType, createGqlClient } from "@/Providers/gqlClients/BaseGqlClient";

export class GqlClient {
  public gqlClient: Sdk;
  constructor(session: Session | null, baseConfig?: BaseGqlClientType, userHeaders?: Record<string, string | null>, useServer?: boolean) {
    const baseGql = createGqlClient(useServer, baseConfig);

    this.gqlClient = getSdk(baseGql.client, async (action) => {
      const headers: Record<string, string> = {
        ...(session && { Authorization: `Bearer ${session.accessToken}` }),
        ...Object.fromEntries(Object.entries(userHeaders ?? {}).filter(([, v]) => v != null) as [string, string][]),
      };
      return action(headers);
    });
  }
}
